import UrunlerService from "../../../services/UrunlerService";
import _ from "lodash";

export default {
  namespaced: true,
  state: () => ({
    kategoriListesi: [],
  }),
  getters: {
    kategorilerGrouped: (state) => (kategoriListesi = null) => {
      // return _.sortBy(cat, 'parent')

      var parseCatsTree = function(cats, parent = [], depth = 0) {
        /**
         * Boş dizi oluştur
         */
        var categories = [];

        if (parent.length === 0) {
          /**
           * En üst kategoriyi al
           */
          parent = _.find(cats, { parent: 0 });
        }

        /**
         * Kategori derinliğini ayarla
         */
        parent.depth = depth;

        /**
         * Üst kategoriyi kaldır
         */
        var catList = _.remove(cats, (o) => {
          return o.parent !== 0;
        });
        /**
         * Kategoriler dizisi içerisine ekle
         */
        categories.push(parent);

        /**
         * Listeden alt kategoriyi/kategorileri getir
         */
        var cat = _.filter(catList, {
          parent: parent.code,
        });

        /**
         * Her seferinde derinliği +1 artır
         */
        depth++;

        /**
         * Alt kategorileri tekrar tekrar oluştur
         */
        if (cat.length > 0) {
          cat.forEach((d) => {
            categories = categories.concat(
              parseCatsTree(JSON.parse(JSON.stringify(catList)), d, depth)
            );
          });
        }

        return categories;
      };

      var grouped = _.mapValues(
        _.groupBy(kategoriListesi ?? state.kategoriListesi, "hierarchy")
      );

      var catList = [];
      Object.keys(grouped).forEach((groupKey) => {
        catList.push(
          parseCatsTree(JSON.parse(JSON.stringify(grouped[groupKey])))
        );
      });
      return catList;
    },
  },
  mutations: {
    setKategoriListesi: (state, data) => {
      state.kategoriListesi = data;
    },
  },
  actions: {
    kategoriListesi: ({ commit }) => {
      return new Promise((resolve, reject) => {
        UrunlerService.kategoriListesi()
          .then((res) => {
            commit("setKategoriListesi", res.data);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kategoriDetay: ({ dispatch }, kategoriCode) => {
      return new Promise((resolve, reject) => {
        UrunlerService.kategoriDetay(kategoriCode)
          .then((res) => {
            dispatch("kategoriListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kategoriEkle: ({ dispatch }, kategoriData) => {
      return new Promise((resolve, reject) => {
        UrunlerService.kategoriEkle(kategoriData)
          .then((res) => {
            dispatch("kategoriListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kategoriGuncelle: ({ dispatch }, kategoriData) => {
      return new Promise((resolve, reject) => {
        UrunlerService.kategoriGuncelle(kategoriData)
          .then((res) => {
            dispatch("kategoriListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    kategoriKaldir: ({ dispatch }, kategoriCode) => {
      return new Promise((resolve, reject) => {
        UrunlerService.kategoriKaldir(kategoriCode)
          .then((res) => {
            dispatch("kategoriListesi");
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
